import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterBar = ({ filters, setFilters }) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-sm p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Search */}
        <div className="relative">
          <Icon
            name="Search"
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
          />
          <Input
            placeholder="Search by name or email..."
            value={filters?.searchTerm}
            onChange={(e) => setFilters({ ...filters, searchTerm: e?.target?.value })}
            className="pl-10"
          />
        </div>

        {/* Role Filter */}
        <Select
          value={filters?.role}
          onChange={(e) => setFilters({ ...filters, role: e?.target?.value })}
        >
          <option value="all">All Roles</option>
          <option value="buyer">Buyers</option>
          <option value="traveler">Travelers</option>
          <option value="admin">Admins</option>
        </Select>

        {/* Verification Status Filter */}
        <Select
          value={filters?.verificationStatus}
          onChange={(e) => setFilters({ ...filters, verificationStatus: e?.target?.value })}
        >
          <option value="all">All Status</option>
          <option value="verified">Verified</option>
          <option value="unverified">Unverified</option>
        </Select>
      </div>
    </div>
  );
};

export default FilterBar;